/**
 * @description Hook utilizado para realizar operações relacionadas aos vestígios fixados em exames de locais de crime
 * @author Diego Sabino Amorim de Araújo
 * @file useVestigioFixadoService.js
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import { useFetch } from './useFetch'

export const useVestigioFixadoService = () => {
  const fetch = useFetch()

  const getTiposVestigiosFixados = async (setProcessando, setTiposVestigiosFixados) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`vestigioFixado/tipos/listarTodos`)
      setTiposVestigiosFixados(response.data.tiposVestigiosFixados)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const cadastrarVestigioFixado = async (dados, setProcessando) => {
    if (setProcessando) setProcessando(true)
    await fetch.post(`vestigioFixado`, dados)
    if (setProcessando) setProcessando(false)
  }

  const deletarVestigioFixado = async (id, setProcessando) => {
    if (setProcessando) setProcessando(true)
    await fetch.del(`vestigioFixado/${id}`)
    if (setProcessando) setProcessando(false)
  }

  const getVestigiosFixadosDeLocalDoExame = async (
    idLocal,
    idExame,
    setVestigiosFixados,
    setProcessando
  ) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`vestigioFixado/deLocal/${idLocal}/${idExame}`)
      setVestigiosFixados(response.data.vestigiosFixados)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  return {
    getTiposVestigiosFixados,
    cadastrarVestigioFixado,
    deletarVestigioFixado,
    getVestigiosFixadosDeLocalDoExame,
  }
}
